import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

export const selectAuth = (state: RootState) => state.auth;

export const selectEnableAuth = createSelector(
  selectAuth,
  (auth) => auth.isAuthorized
);

export const selectCurrentUser = createSelector(
  selectAuth,
  (auth) => auth.currentUser
);

export const selectIsSuperAdmin = createSelector(
  selectCurrentUser,
  (user) => user?.role === 'super_admin'
);

export const selectCurrentCompany = createSelector(
  selectCurrentUser,
  (user) => user?.company ?? null
);
